// Libs
import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

// Services & Helpers
import TextHelpers from 'helpers/TextHelpers';

//-------------------------------------------------------------------------------------------------------------------

class Enablement extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            enablement: null
        };
    }

    shouldComponentUpdate(nextProps) {
        if (typeof (this.props.requestID) == 'undefined') {
            return true;
        }
        return (this.props.requestID != nextProps.requestID);
    }

    render() {
        const {
            enablement
        } = this.props;

        // Only show instructors with at least one column filled in
        const instructors = enablement.instructors.filter(i =>
            !!enablement.courses.find(c => this.renderCellContent(i, c.id))
        );

        // Count totals
        const totalsByCourse = {};
        enablement.courses.forEach(c => {
            totalsByCourse[c.id] = {
                numApproved: 0,
                numRamping: 0
            };
            enablement.instructors.forEach(i => {
                const cellContents = this.renderCellContent(i, c.id);
                if (cellContents == 'Approved') {
                    totalsByCourse[c.id].numApproved++;
                }
                else if (cellContents == 'Ramping' || cellContents.indexOf('Expected') != -1) {
                    totalsByCourse[c.id].numRamping++;
                }
            });
        });

        return (
            <table className="table sticky-table enablement">
                <thead>
                    <tr>
                        <th className="sticky-column">Instructor</th>
                        {enablement.courses.map(course =>
                            <th key={course.id}>
                                {course.name}
                            </th>
                        )}
                    </tr>
                    <tr>
                        <th className="sticky-column"># Approved</th>
                        {enablement.courses.map(course =>
                            <td key={course.id} className="num-approved-cell">
                                {(totalsByCourse[course.id] || {}).numApproved || 0}
                            </td>
                        )}
                    </tr>
                    <tr>
                        <th className="sticky-column"># Ramping</th>
                        {enablement.courses.map(course =>
                            <td key={course.id} className="num-ramping-cell">
                                {(totalsByCourse[course.id] || {}).numRamping || 0}
                            </td>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {instructors.map(instructor =>
                        <tr key={instructor.id}>
                            <th>
                                <Link to={'/instructor/' + instructor.slug}>
                                    {TextHelpers.formatInstructorName(instructor)}
                                </Link>
                                <div className="instructor-geos">
                                    ({instructor.geos.map((geo, index) =>
                                        <React.Fragment key={index}>
                                            {index != 0 && ', '}
                                            {geo.isPrimary ? <b>{geo.name}</b> : geo.name}
                                        </React.Fragment>)
                                    })
                                </div>
                            </th>
                            {enablement.courses.map(course =>
                                <td key={course.id}>
                                    {this.renderCellContent(instructor, course.id)}
                                </td>
                            )}
                        </tr>
                    )}
                </tbody>
            </table>

        );
    }

    renderCellContent(instructor, courseID) {
        const { statuses } = this.props;
        const courseInfo = instructor.courses[courseID];
        if (courseInfo) {
            if (courseInfo.isApproved) {
                if (statuses.approved) {
                    return 'Approved';
                }
            } else if (courseInfo.dateExamPassed) {
                if (statuses.ramping) {
                    return 'Expected ' + moment(courseInfo.dateExamPassed).format('DD MMMM YYYY');
                }
            } else if (statuses.ramping) {
                return 'Ramping';
            }
        } else {
            if (statuses.notApproved) {
                return 'Not approved';
            }
        }
        return '';
    }
}

export default Enablement;